export default "__VITE_ASSET__18154a30__"